import { Link } from "react-router-dom";
import { Fragment } from "react";

export const Home = () => <Link to="/">Home One</Link>;

export const Pages = () => (
  <Fragment>
    <li>
      <Link to="/pricing">Pricing Plan</Link>
    </li>
    <li>
      <Link to="/faq">Help &amp; FAQ</Link>
    </li>
    <li>
      <Link to="/gallery">Our Gallery</Link>
    </li>
    <li>
      <Link to="/appointments">Appointment</Link>
    </li>
  </Fragment>
);

export const Services = () => (
  <Fragment>
    <li>
      <Link to="/service">Service One</Link>
    </li>
    <li>
      <Link to="/service-two">Service Two</Link>
    </li>
    <li>
      <Link to="/service-details">Service Details</Link>
    </li>
  </Fragment>
);

export const Doctor = () => (
  <Fragment>
    <li>
      <Link to="/doctor">Doctor</Link>
    </li>
    <li>
      <Link to="/doctor-details">Doctor Details</Link>
    </li>
  </Fragment>
);

export const Blog = () => (
  <Fragment>
    <li>
      <Link to="/blog-standard">Blog Standard</Link>
    </li>
    <li>
      <Link to="/blog-details">Blog Details</Link>
    </li>
  </Fragment>
);

export const Shop = () => (
  <Fragment>
    <li>
      <Link to="/shop">Shop</Link>
    </li>
    <li>
      <Link to="/product-details">Shop Details</Link>
    </li>
  </Fragment>
);
